module.exports = __webpack_public_path__ + "img/eye.af607d16.svg";